import { useMemo } from 'react';
import { useIsAutorizedUser } from 'store/features/auth';
import { useUserPermissions } from 'entities/user';
import { useIsMapsRegional } from 'store/features/auth';

export const useServicesFuelSelectVisibility = () => {
  const permissions = useUserPermissions();
  const isAutorizedUser = useIsAutorizedUser();
  const isMapsRegional = useIsMapsRegional();

  return useMemo(() => ({
    buildingRouteFilter: permissions.buildingRouteServiceSelect && isAutorizedUser && !isMapsRegional
  }), [
    permissions,
    isAutorizedUser,
    isMapsRegional
  ]);
};
